module.exports = __webpack_public_path__ + "static/media/pegasus.28ac2680.svg";